module.exports = __webpack_public_path__ + "fec80806f55ada576a6d253ae94c7afa.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/year-in-review/2017/icons/personal-energy-light.png
// module id = 1872
// module chunks = 1